<ng-container *ngIf="isCreditsKeyMetrics; else keyMetrics">
    <dl class="key-metrics">
        <app-metric
            *ngFor="let metric of metrics"
            [metric]="metric"
            [isCreditsKeyMetrics]="true"
            [isPrintMode]="isPrintMode"
        ></app-metric>
    </dl>
</ng-container>

<ng-template #keyMetrics>
    <dl class="key-metrics">
        <app-metric
            *ngFor="let metric of metrics"
            [metric]="metric"
            [isPrintMode]="isPrintMode"
        ></app-metric>
    </dl>
</ng-template>
